import { instance2 } from "App/constants";

export const urlPembayaran ="/wmsAsset/pembayaran/list-byid-pembelian";
export const getAllKelasKamar = async () => {
  try {
    const api = await instance2.get("/bed/listkelaskamar");
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "pembelian_id",
    disablePadding: false,
    label: "PEMBELIAN ID",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_supplier",
    disablePadding: false,
    label: "NAMA SUPPLIER",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "no_faktur",
    disablePadding: false,
    label: "NO. FAKTUR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal_masuk",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah_bayar",
    disablePadding: false,
    label: "JUMLAH BAYAR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaKas",
    disablePadding: false,
    label: "KAS",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "tipe_pembayaran_id",
    disablePadding: false,
    label: "TIPE PEMBAYARAN",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "tipe_kartu",
    disablePadding: false,
    label: "TIPE KARTU",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_kartu",
    disablePadding: false,
    label: "NO KARTU",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_transfer",
    disablePadding: false,
    label: "NO TRANSFER",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
